import React from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { FlowEditContext } from "../FlowEditContext";

interface IBaseStepStrategy {
    editContext: FlowEditContext;
}

export abstract class BaseStepStrategy extends React.Component<IBaseStepStrategy> {
    @AutoBind
    onUnselectStepStrategyConnect() {
        this.props.editContext.selectedStepStrategy = null;
    }
}
